var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"wrapper-inner"}},[_c('head-comp'),_c('router-view')],1)]),_c('AnchorComp',{attrs:{"flag_hidden":_vm.flag_visible,"footerShow":_vm.footerShow,"top":_vm.top}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }